export default "__VITE_ASSET__65811a0c__"